<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>{{buildType}}</h4>

    <button
      mat-button
      [mat-dialog-close]=""
      (click)="onCancel()"
      cdkFocusInitial
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <p mat-dialog-content class="dialog-content">
    Do you want to include any states?
  </p>
  <p
    mat-dialog-content
    class="dialog-content dialog-note"
    innerHtml="{{tips}}"
  ></p>
  <div mat-dialog-content class="evenly">
    @for (st of data.states; track st; let i = $index) {
    <mat-checkbox
      (change)="onStateClick($event, st)"
      [disabled]="(stateChecked.length == 1
        && this.data.build !== 'X3.0'
        && this.data.build !== 'C3.0'
        && this.data.build !== 'reghub'
        && this.data.build !== 'csv'
        && this.data.build !== 'regcompare'
        && !stateChecked.includes(st)) ||
        (stateChecked.length == 5 && this.data.build == 'regcompare' && !stateChecked.includes(st))"
      [ngModel]="this.stateChecked.includes(st)"
      >{{st}}
    </mat-checkbox>
    }
  </div>
  <hr class="solid" />
  @if (data.build == 'X3.0') {
  <mat-checkbox
    matTooltip="Unlocking means you can format or edit the file. Note, STP will not support Unlocked Xcelerators if changes to the file break formulas or cause other issues."
    matTooltipClass="tooltip2"
    (change)="onUnlockClick($event)"
    class="emphasize"
  >
    Unlock Xcelerator
  </mat-checkbox>
  }
  <div mat-dialog-actions [ngClass]="{'dialog-confirm': data.build === 'X3.0'}">
    <div>
      <button
        mat-button
        (click)="onConfirm()"
        class="button-close"
        cdkFocusInitial
      >
        Confirm
      </button>
      <button
        mat-button
        (click)="onCancel()"
        mat-dialog-close
        class="button-close"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
